import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogPositiveActionButton,
} from "..";

function CustomConfirmationDialog({
  onClose,
  open,
  dialogText,
  dialogTitle = "Confirmation",
  closeBtnText = "Ok",
  ...rest
}) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} open={open} onClose={onClose}>
      <DialogTitle>{t(dialogTitle)}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t(dialogText)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogPositiveActionButton
          onClick={onClose}
          data-test-id="dialog-close-button"
        >
          {t(closeBtnText)}
        </DialogPositiveActionButton>
      </DialogActions>
    </Dialog>
  );
}

export default memo(CustomConfirmationDialog);
